<script>
import moment from 'moment/moment'

import GraphicArea from '@/components/GraphicArea.vue'
import Loading from '@/components/Loading.vue'
import http from '@/utils/http'

export default {
  name: 'EtaChartTipoDado',
  components: { Loading, GraphicArea },
  props: {
    tipo: {
      type: String,
      required: true,
    },
    etaId: {
      type: String,
      required: true,
    },
    periodicidade: {
      type: String,
      required: true,
    },
    showDots: {
      type: Boolean,
      default: true,
    },
    from: {
      type: Date,
      required: true,
    },
    to: {
      type: Date,
      required: true,
    },
  },
  data() {
    return {
      series: [],
      loadingData: true,
      chartOptions: {
        colors: [
          '#008FFB',
          '#00E396',
          '#FEB019',
          '#FF4560',
          '#775DD0',
          '#966e23',
          '#ff07dd',
          '#4af0ff',
          '#000dff',
          '#3f3f3f',
        ],
        markers: {
          size: this.showDots ? 4 : 0,
          hover: {
            size: 10,
          },
        },
        chart: {
          type: 'line',
          zoom: {
            enabled: false,
          },
        },
        dataLabels: {
          enabled: this.showDots,
          // eslint-disable-next-line no-unused-vars
          formatter: function (val, opts) {
            return val.toFixed(2)
          },
          style: {
            fontSize: '0.6rem',
          },
          background: {
            enabled: true,
            foreColor: '#fff',
            padding: 4,
            borderRadius: 2,
            borderWidth: 1,
            borderColor: '#fff',
            opacity: 0.9,
            dropShadow: {
              enabled: false,
              top: 1,
              left: 1,
              blur: 1,
              color: '#000',
              opacity: 0.45,
            },
          },
        },
        stroke: {
          width: 2,
          curve: 'smooth',
        },
        title: {
          text: `${this.tipo}`,
          align: 'left',
        },
        grid: {
          row: {
            colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
            opacity: 0.5,
          },
        },
        xaxis: {
          type: 'datetime',
          labels: {
            formatter: (value, timestamp) => {
              let format = 'HH:mm'

              if (this.showDots === false) {
                format = 'HH:mm DD/MM'
              }

              if (this.periodicidade === 'SEMANAL') {
                format = 'DD/MM'
              }

              return moment(new Date(timestamp)).format(format)
            },
          },
          max: this.to.getTime(),
          min: this.from.getTime(),
        },
        yaxis: {
          labels: {
            formatter: function (val) {
              return val.toFixed(2)
            },
          },
          tickAmount: 5,
          min: 0,
          max: (x) => x * 1.05,
        },
      },
    }
  },
  beforeMount() {
    this.loadData()
  },
  methods: {
    async loadData() {
      this.loadingData = true
      await this.buscarDados().finally(() => {
        this.loadingData = false
      })
    },
    async buscarDados() {
      http.eta
        .get(`eta/${this.etaId}/dados-agrupados-tipo`, {
          tipo: this.tipo,
          periodicidade: this.periodicidade,
          // now - 24 hours UTC
          from: this.from.toISOString(),
          to: this.to.toISOString(),
        })
        .then((data) => {
          this.series = data.map((e) => ({
            name: e.nome,
            data: e.data,
          }))
        })
    },
  },
}
</script>

<template>
  <div :id="`etachart${_uid}`">
    <loading :loading="loadingData" />
    <apexchart
      v-if="!loadingData"
      type="line"
      height="350vh"
      :options.sync="chartOptions"
      :series="series"
    />
  </div>
</template>

<style scoped lang="scss"></style>
